/**
 * Client-side Instrumentation
 *
 * Runs before React hydration begins.
 * Initialize GTM consent queue and other client-side monitoring.
 */

import { GTMConsentQueue } from "./lib/gtm-consent-queue";

// Initialize the GTM consent queue system
const consentQueue = new GTMConsentQueue();

// Make debug methods available globally in development
if (process.env.NODE_ENV === "development") {
	(window as Window).gtmConsentQueue = {
		getStatus: () => consentQueue.getQueueStatus(),
		forceFlush: () => consentQueue.forceFlush(),
		// Test function to simulate flush_events
		simulateFlushEvents: () => {
			if (window.dataLayer) {
				window.dataLayer.push({
					event: "flush_events",
				});
			}
		},
	};

	console.log("[GTM Consent Queue] Debug methods available: window.gtmConsentQueue");
}

declare global {
	interface Window {
		gtmConsentQueue?: {
			getStatus: () => {
				queueLength: number;
				consentReceived: boolean;
				queuedEvents: string[];
			};
			forceFlush: () => void;
			simulateFlushEvents: () => void;
		};
	}
}
